export interface DonutChartSegment {
  label: string;
  value: number;
  color: string;
}
